import { IFile, ITaskTimelineToFile } from "@evennt-tech/api-v2-core";

function unpackFiles(actionFiles?: ITaskTimelineToFile[]) {
  if (!actionFiles) {
    return;
  }
  return actionFiles.map((actionFile) => {
    const file = actionFile.file as IFile;
    const splittedName = file.name.split(".");

    return {
      name: file.title,
      size: `${(file.size / 1024).toFixed(2)}KB`,
      type: splittedName[splittedName?.length - 1],
      link: file.url,
    } as const;
  });
}

export default unpackFiles;
